
'use strict'

import Input from './Input';

class Subscribe{
    constructor(element){
        if(element==null){
            return;
        }
        this.main = element;

        this._inputEmail = new Input(this.main.querySelector('input[name="email"]'));
        this._sendBtn =  this.main.querySelector('.send_btn');
        
        this._sending = false;

        this._sendBtn.addEventListener('click', this._onClickSendBtn.bind(this));        
    }

    _onClickSendBtn(e){
        //console.log('ENTRO:Subscribe');
        if(!this._sending){
            if(!this._inputEmail.isValidEmail){
                this._inputEmail.error = true;
                
                App.alertMessage.show(this.main.getAttribute('data-msg-error'));
            }else{
                
                let requestData = {
                    email: this._inputEmail.value,
                    lang: App.lang
                }

                this._sending = true;
                this._sendBtn.classList.add('form__input-btn--loading');

                fetch(App.baseUrl + 'subscribe', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache'
                    },
                    body: JSON.stringify(requestData)
                })
                .then((response) => {return response.json()})
                .then((data) => {
                    this._sending = false;
                    this._sendBtn.classList.remove('form__input-btn--loading');

                    App.alertMessage.show(this.main.getAttribute('data-msg-success'), true);
                    this._inputEmail.reset();
                });
            
            }      
        }
    }
}

export default Subscribe;